import { useWeb3React } from '@web3-react/core'
import { SUPPORTED_RINGX_CHAIN_IDS } from 'constants/chains'

export function useNetworkSupportsRingX() {
  const { chainId } = useWeb3React()
  return chainId && SUPPORTED_RINGX_CHAIN_IDS.includes(chainId)
}
